import { createInvokeWithMetadata, } from "@todesktop/client-util";
export const { invoke, construct, releaseMemory } = createInvokeWithMetadata("client-core", "1.0.0-dev");
/**
 * @internal
 * @privateRemarks
 * Should not be hardcoded.
 */
export default invoke;
